// src/utils/capacityStages.js
//
// CAPACITY-DEFINITION-FIX (MP-11/12): Single, authoritative definition of
// "usable capacity" shared across every surface that sums seats, computes
// surplus, or evaluates Space Fit verdicts.
//
// Stages included:   operational · dormant
// Stages excluded:   build (capacity not yet live), vacated (no active occupancy),
//                    closed (retired / decommissioned)
//
// Import this constant at every call-site rather than repeating the literal
// array.  Any future stage vocabulary change flows from here automatically.
//
// Server-side callers (server/routes/plan.js) define the equivalent Set inline
// because server code cannot import from src/.

export const USABLE_CAPACITY_STAGES = ["operational", "dormant"];

// Convenience Set for O(1) membership tests in pure-JS (non-React) callers.
export const USABLE_CAPACITY_STAGES_SET = new Set(USABLE_CAPACITY_STAGES);
